import { render, staticRenderFns } from "./selectClient.vue?vue&type=template&id=36af305c&"
import script from "./selectClient.vue?vue&type=script&lang=js&"
export * from "./selectClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VueCardTitle }  from '@/components'
installComponents(component, {VAutocomplete,VAvatar,VBtn,VCard,VCardText,VCol,VDialog,VDivider,VIcon,VImg,VListItemAction,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle,VNavigationDrawer,VRow,VSpacer,VTooltip,VueCardTitle})


/* vuetify-loader */
import installIcons from "!../../../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiAccountCircle } from '@mdi/js';
import { mdiDomain } from '@mdi/js';
import { mdiFileDocumentEdit } from '@mdi/js';
installIcons(component, {mdiAccountCircle,mdiDomain,mdiFileDocumentEdit})
